import React from 'react';
import { Route, Routes } from 'react-router-dom';

import HeaderSecondary from '@components/HeaderSecondary';

import PersonalAccidentQuoteBuyNewPage from './PersonalAccidentQuoteBuyNewPage';
import PersonalAccidentQuoteReviewPage from './PersonalAccidentQuoteReviewPage';
import PersonalAccidentQuoteBuyEditPage from './PersonalAccidentQuoteBuyEditPage';
import PersonalAccidentQuoteBuyCustomPage from './PersonalAccidentQuoteBuyCustomPage';

const PersonalAccidentQuoteBuyRoute = () => {
  return (
    <>
      <HeaderSecondary />
      <Routes>
        <Route path="/*" element={<PersonalAccidentQuoteBuyNewPage />} />
        <Route path=":orderNumber/edit/*" element={<PersonalAccidentQuoteBuyEditPage />} />
        <Route path=":orderNumber/review" element={<PersonalAccidentQuoteReviewPage />} />
        <Route path=":orderNumber/custom" element={<PersonalAccidentQuoteBuyCustomPage />} />
      </Routes>
    </>
  );
};

export { PersonalAccidentQuoteBuyRoute };
